// extracted by mini-css-extract-plugin
export var alertIcon = "_nv-0";